
<div class="p-grid">
    <div class="p-col-12" >
        <p-menubar >
            <ng-template pTemplate="start" style="width: 100%;">
                <h2 style="display: inline;">POS - </h2>
                <span style="width: fit-content; ">
                    <p-dropdown placeholder="Choose Channel" [options]="channelsN"
                        (onChange)="changeChannel(selectedChannelN)" [(ngModel)]="selectedChannelN" optionLabel="name"
                        appendTo="body" class="customDD" [baseZIndex]="0">
                    </p-dropdown>
                </span>
            </ng-template>
        </p-menubar>
    </div>
</div>



<div style="flex-grow: 1">
    <div class="p-grid">
        <ng-container>
            <div [ngClass]="{'p-col-12 p-lg-12': selectedView=='list', 'p-col-12 p-lg-2':selectedView=='split'}">
                <div class="card">
                    <p-table [value]="product" responsiveLayout="scroll" dataKey="id"
                        [columns]="selectedView == 'list'? cols: cols.slice(0,1)" [lazy]="true" [paginator]="true"
                        [totalRecords]="totalRecord" [rows]="pageSize" [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="rowsPerPage" (onRowSelect)="onRowSelect($event)"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        selectionMode="single" [(selection)]="selectedData" (onPage)="getData1($event)"
                        >
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th id="header" *ngFor="let col of columns">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                <td *ngFor="let col of columns">
                            <span [ngClass]="{'report-link': col.field === 'accountId'}"
                            (click)="col.field  === 'accountId' ? onAccount(rowData) :'' " >
                            {{rowData[col.field]}}
                        </span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
            <div class="p-col-12 p-lg-10" *ngIf="selectedView == 'split'">
                <div class="tabviewIcons">
                    <div class="btnBars" (click)="backListView()">
                        <i class="pi pi-times"></i>
                    </div>
                </div>
                <p-tabView>
                    <p-tabPanel header="Details">
                        <app-pos-details [selectedData]="selectedData" [posConsumerId]="posConsumerId"
                            [vendorName]="vendorName"></app-pos-details>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </ng-container>
    </div>
</div>

<app-edit-account *ngIf="displayAccountViewEdit" [displayEditViewDialog]="displayAccountViewEdit" [displayView]="true"
    [selectedAccountId]="selectedAccountId" [selectedChannelId]="selectedAccountChannelId"
    (closeModal)="closeAccountViewEditModal()"> </app-edit-account>
<p-toast [baseZIndex]="1000000"></p-toast>



